import store from './index'
import { locationsActions } from './locations-slice';
import { handleError, handleSessionExpired } from './error-handler';

export const fetchLocationsList = () => {
    return async (dispatch) => {
        const fetchData = async () => {
            dispatch(locationsActions.setIsLoading(true))
            var bearer = 'Bearer ' + localStorage.getItem('token');
            const url = store.getState().auth.url
            const response = await fetch(url + 'api/locations',{
                headers:{
                    'Authorization': bearer,
                }
            });

            if (!response.ok) {
                if(response.status === 401){ 
                    handleSessionExpired(dispatch, bearer)
                    throw new Error('Your session has expired. Please log in again.')
                }
                else{ throw new Error('Could not fetch locations list.') }
            }
            const data = await response.json()
            return data;
        };

        try {
            const locationsData = await fetchData()
            dispatch(locationsActions.loadLocations({ locations: locationsData || [] }))

        } catch (error) {
            handleError(dispatch, error)
        }
        finally {
            dispatch(locationsActions.setIsLoading(false))

        }
    };
};

